export default __webpack_public_path__ + "static/17b-2bc273d25573dd75dc5a9bee674efe8c.png";